import { SupplierGet, Ulid } from "@kase/my-marathon-communication";
import { ReadonlySignal } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import {
    createEmitter,
    createListController,
    getIdWithCompany,
} from "../utils";
import { Supplier } from "./interfaces";

export const makeSupplier = ({ connection, company }: ApiSliceParams) => {
    const { emit, on, off } = createEmitter<Supplier>();
    const {
        items: suppliers,
        loading: getLoading,
        loaded: getLoaded,
        listen: listenCompany,
    } = createListController<SupplierGet, Supplier, string>({
        name: "supplier",
        connection,
        list: (con, company) => con.supplier.items({ company }),
        getId: (item, company) => getIdWithCompany(item.id, company),
        getKey: (company) => company,
        emit,
    });
    let loadingSignal: ReadonlySignal<boolean>;
    let loadedSignal: ReadonlySignal<boolean>;

    const listen = () => listenCompany(company.value);

    const get = (
        id: string | Readonly<Ulid> | null | undefined,
        company: string,
    ) => {
        if (!id) {
            return null;
        }

        const key = getIdWithCompany(id, company);

        return suppliers.value.find((s) => s.id === key) ?? null;
    };

    return {
        suppliers,

        get loading() {
            if (!loadingSignal) {
                loadingSignal = getLoading(company.value);
            }

            return loadingSignal;
        },

        get loaded() {
            if (!loadedSignal) {
                loadedSignal = getLoaded(company.value);
            }

            return loadedSignal;
        },

        on,
        off,
        listen,
        listenCompany,
        get,
    };
};
